import request from "@/utils/request.js"

// 车店-新增(跨租户)
export const addBikeStoreIgnore = (formData) => {
    return request.post(`/bikeStore/ignoreTenant`, formData)
}

// 车店-详情(跨租户)
export const getBikeStoreIgnore = (id) => {
    return request.get(`/bikeStore/ignoreTenant/${id}`)
}

// 车店-修改(跨租户)
export const updateBikeStoreIgnore = (updateData) => {
    return request.put(`/bikeStore/ignoreTenant`, updateData);
};
